<!--
 * @Description: 订单管理平台订单
 * @Author: gao shuai
 * @Date: 2020-02-22 15:56:35
 * @LastEditTime: 2020-09-01 16:05:33
 * @LastEditors: gao shuai
 -->

<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>平台订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <table>
        <tr>
          <td>
            <span class='tit'>开始时间：</span>
            <!-- <el-date-picker style="width:338px;" v-model="ordertime" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
            <el-date-picker style="width:190px;" v-model="ordertime1" size="small" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
            </el-date-picker> <span style="font-size:14px;">至 </span>
            <el-date-picker style="width:190px;" v-model="ordertime2" size="small" default-time="23:59:59"
              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
            </el-date-picker>
          </td>
          <td>
            <span class='tit'>充值通道：</span>
            <span class="txtbox">
              <el-select style="width:120px;" v-model="rechargeChannel" clearable size="small" placeholder="请选择">
                <el-option v-for="(item, i) in Channeldrow" :key="'Channel' + i" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </span>
          </td>
          <td>
            <span class='tit'>充值方式：</span>
            <span class="txtbox">
              <el-select style="width:120px;" v-model="rechargemode" clearable size="small" placeholder="请选择">
                <el-option v-for="(item, i) in rechargedrow" :key="'recharge' + i" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </span>
          </td>
          <td>
            <span class='tit'>订单状态：</span>
            <span class="txtbox">
              <el-select style="width:120px;" v-model="Orderstatus" clearable size="small" placeholder="请选择">
                <el-option v-for="(item, i) in Orderdrow" :key="'Order' + i" :label="item.text"
                  :value="item.value"></el-option>
              </el-select>
            </span>
          </td>
          <td>
            <el-button size="small" type="primary" @click="checkdata">查询</el-button>
          </td>
        </tr>
        <tr>
          <td>
            <span class='tit'>充值金额：</span>
            <span class="txtbox">
              <el-input style="width:190px;" size="small" v-model="ontherecharge"
                @input="ontherecharge = intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
              <el-input style="width:190px;" size="small" v-model="undertherecharge"
                @input="undertherecharge = intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
            </span>
          </td>
          <td>
            <span class='tit'>订单编号：</span>
            <span class="txtbox">
              <el-input style="width:120px;" size="small" v-model="ordernumber" placeholder="请输入内容"></el-input>
            </span>
          </td>
          <td>
            <span class='tit'>商户账号：</span>
            <span class="txtbox">
              <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
            </span>
          </td>
          <td>
            <span class='tit'>游戏账号：</span>
            <span class="txtbox">
              <el-input style="width:120px;" size="small" v-model="gameaccount" placeholder="请输入内容"></el-input>
            </span>
          </td>
          <td>
            <el-button size="small" type="success" @click="reseting">重置</el-button>
          </td>
        </tr>
      </table>
      <!-- <ul class="clearfix">
        <li>
          <span class='tit'>开始时间：</span>
          <el-date-picker style="width:338px;" v-model="ordertime" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
        </li>
        <li>
          <span class='tit'>充值通道：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="rechargeChannel" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in Channeldrow" :key="'Channel'+i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>充值方式：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="rechargemode" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in rechargedrow" :key="'recharge'+i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>订单状态：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="Orderstatus" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in Orderdrow" :key="'Order'+i" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>充值金额：</span>
          <span class="txtbox">
            <el-input style="width:157px;" size="small" v-model="ontherecharge" @input="ontherecharge=intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:157px;" size="small" v-model="undertherecharge" @input="undertherecharge=intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <el-button size="small" type="primary" @click="checkdata">查询</el-button>
        </li>
        <li>
          <span class='tit'>截止时间：</span>
          <el-date-picker style="width:185px;" size="small" v-model="endTime" type="datetime" placeholder="选择日期时间" default-time="23:59:59"></el-date-picker>
        </li>
        <li>
          <span class='tit'>订单编号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="ordernumber" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>游戏账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="gameaccount" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>导出TXT：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="derive" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in derivedrow" :key="'derive'+i" :label="item.text" :value="item.value" @click.native="exportExcel(item.value)"></el-option>
            </el-select>
          </span>
        </li>
      </ul> -->
      <!-- <div class="btnbox">
        <p>
          <el-button size="small" type="primary" @click="checkdata">查询</el-button>
        </p>
        <p class="mgt10">
          <el-button size="small" type="success" @click="reseting">重置</el-button>
        </p>
      </div> -->
    </div>
    <div class="tableinfo mgt10">
      <table>
        <tr>
          <td><span class="c_3fa396">充值金额统计：</span>{{ upinfo.amount }}元</td>
          <td><span class="c_3fa396">订单笔数：</span>{{ upinfo.successCount }}</td>
          <td><span class="c_3fa396">付款金额：</span>{{ upinfo.payAmount }}元</td>
          <td><span class="c_3fa396">商户收入：</span>{{ upinfo.merchantProfit }}元</td>
          <td><span
              class="c_3fa396">平台收入：</span>{{ (parseFloat(upinfo.platformProfit) + parseFloat(upinfo.tailAmountProfit)).toFixed(2) }}元
          </td>
          <td><span class="c_3fa396">风控收入：</span>{{ upinfo.randomMoney }}元</td>
        </tr>
        <tr>
          <td><span>昨日此时充值：</span>{{ downinfo.amount }}元</td>
          <td><span>订单笔数：</span>{{ downinfo.successCount }}</td>
          <td><span>付款金额：</span>{{ downinfo.payAmount }}元</td>
          <td><span>商户收入：</span>{{ downinfo.merchantProfit }}元</td>
          <td>
            <span>平台收入：</span>{{ (parseFloat(downinfo.platformProfit) + parseFloat(downinfo.tailAmountProfit)).toFixed(2) }}元
          </td>
          <td>
            <span>风控收入：</span>{{ ( parseFloat(downinfo.randomMoney)).toFixed(2) }}元
          </td>
        </tr>
      </table>
      <div class="btn">
        <el-button size="small" type="info" @click.prevent="dialog1.show = true">清空订单数据</el-button>
      </div>
    </div>
    <!-- <el-progress :text-inside="true" :stroke-width="14" :percentage="upinfo.successRate*100" stroke-linecap="square"></el-progress> -->
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column prop="productName" label="充值方式" width="100">
        </el-table-column>
        <el-table-column prop="orderDate" label="下单时间" width="160">
        </el-table-column>
        <el-table-column label="订单号" width="210">
          <template slot-scope="scope">
            <span style="color:green;cursor:pointer;text-decoration:underline;"
              @click="orderdetail(scope.row.id)">{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="playerAccount" label="充值账号" width="300">
        </el-table-column>
        <el-table-column label="提交金额">
          <template slot-scope="scope">
            <span>{{ scope.row.amount ? scope.row.amount.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商户收入">
          <template slot-scope="scope">
            <span>{{ scope.row.merchantProfit ? scope.row.merchantProfit.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款金额">
          <template slot-scope="scope">
            <span>{{ scope.row.payAmount ? scope.row.payAmount.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="随机金额">
          <template slot-scope="scope">
            <span>{{ scope.row.randomMoney ? scope.row.randomMoney.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台收入">
          <template slot-scope="scope">
            <span>{{ scope.row.platformProfit ? scope.row.platformProfit.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="partitionName" label="分区" width="240">
        </el-table-column>
        <el-table-column prop="account" label="商户账号">
        </el-table-column>
        <el-table-column prop="galleryName" label="充值通道">
        </el-table-column>
        <el-table-column label="订单状态" width="95">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.orderStatus === 2" class="item" effect="dark" :content="waitFlag ? '请稍后点击下发' : '点击下发'"
              placement="bottom">
              <span style="color:#f56c6c;cursor:pointer;"
                @click="orderSent(scope.row.orderNumber, scope.row.partitionId, scope.$index)"><i
                  :class="{ 'el-icon-loading': waitFlag && waitFlagIndex === scope.$index }"></i>等待下发</span>
            </el-tooltip>
            <span v-else
              :style="{ color: scope.row.orderStatus === 0 ? '#409eff' : scope.row.orderStatus === 1 ? 'green' : scope.row.orderStatus === 2 ? '#f56c6c' : '#e6a23c' }">{{ scope.row.orderStatus | orderState }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" :disabled="scope.row.orderStatus !== 1"
              @click="Deductiontip(scope.row.id)">扣单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 订单详情的弹框 -->
    <el-dialog title="订单详情" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="800px">
      <table class="dialogtable">
        <tr>
          <td width="18%" class="tit">系统订单</td>
          <td width="32%">{{ dialog.sysorder }}</td>
          <td width="18%" class="tit">服务订单</td>
          <td width="32%">{{ dialog.serverorder }}</td>
        </tr>
        <tr>
          <td class="tit">商户账号</td>
          <td>{{ dialog.merchantaccount }}</td>
          <td class="tit">分区</td>
          <td class="red">{{ dialog.area }}</td>
        </tr>
        <tr>
          <td class="tit">玩家账号</td>
          <td>{{ dialog.playaccount }}</td>
          <td class="tit">充值方式</td>
          <td><span>{{ dialog.chargetype2 }}</span>(<span style="color:red;">{{ dialog.chargetype1 }}</span>)</td>
        </tr>
        <tr>
          <td class="tit">下单时间</td>
          <td>{{ dialog.ordertime }}</td>
          <td class="tit">完成时间</td>
          <td>{{ dialog.finishtime }}</td>
        </tr>
        <tr>
          <td class="tit">订单金额</td>
          <td>{{ dialog.ordermoney }}</td>
          <td class="tit">付款金额</td>
          <td class="red">{{ dialog.paymoney }}</td>
        </tr>
        <tr>
          <td class="tit">赠送金额</td>
          <td>{{ dialog.givemoney }}</td>
          <td class="tit">红包赠送</td>
          <td>{{ dialog.redmoney }}</td>
        </tr>
        <tr>
          <td class="tit">商户收入</td>
          <td>{{ dialog.merchantProfit }}</td>
          <td class="tit">商户比率</td>
          <td class="red">{{ dialog.merchantrate }}%</td>
        </tr>
        <tr>
          <td class="tit">订单收入</td>
          <td>{{ dialog.orderProfit }}</td>
          <td class="tit">平台比率</td>
          <td class="red">{{ dialog.platrate }}%</td>
        </tr>
        <!-- <tr>
          <td class="tit">风控收入</td>
          <td>{{dialog.tialProfit}}</td>
          <td class="tit">风控比率</td>
          <td class="red">{{dialog.tialRate}}%</td>
        </tr> -->
        <tr>
          <td class="tit">兑换比例</td>
          <td>1 : {{ dialog.changeRank }}</td>
          <td class="tit">订单状态</td>
          <td><span
              :style="{ color: dialog.orderState === 0 ? '#409eff' : dialog.orderState === 1 ? 'green' : dialog.orderState === 2 ? '#f56c6c' : '#e6a23c' }">{{ dialog.orderState | orderState }}</span>
          </td>
        </tr>
        <tr>
          <td class="tit">玩家ＩＰ</td>
          <td>{{ dialog.playerIp }}</td>
          <td class="tit">玩家ＱＱ</td>
          <td>{{ dialog.playerQQ }}</td>
        </tr>
      </table>
      <p class="tc pdt15 pdb20">
        <el-button size="small" type="danger" @click="refundOrder">退款</el-button>
      </p>
    </el-dialog>
    <!-- 清空订单数据的弹框 -->
    <el-dialog title="提示" :visible.sync="dialog1.show" @close="dialoginit1" :close-on-click-modal="false"
      custom-class="gs_dialog" width="550px">
      <div class="deleteTip">
        <p class="tip">1.该操作将会清除指定日期前的订单数据,提现记录,发布站来路,系统日志。</p>
        <p class="tip">2.数据清除后不能恢复,您可以先备份数据库，再清除。</p>
        <p class="tip">3.填写商户ID可保留该商户的所有数据,未填写清除系统所有数据</p>
        <div class="timebox">
          <span class="mgr10">清除的时间点：</span>
          <el-date-picker style="width:185px;" size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="dialog1.time"
            type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions0">
          </el-date-picker>
        </div>
        <div class="inputBox">
          <span class="tit">排除商户ID : </span>
          <!-- <ul>
            <li v-for="(item,i) in dialog1.merchantId" :key="'mercha'+i">
              <el-input style="width:184px; margin-right: 15px;" size="small" v-model="item.id" placeholder="请输入内容"></el-input>
              <el-button size="mini" type="success">增加</el-button>
            </li>
          </ul> -->
          <div class="merchantBox">
            <el-tag :key="tag" v-for="(tag, i) in dialog1.merchantId" closable :disable-transitions="false"
              @close="handleClose(tag, i)">
              {{ tag }}
            </el-tag>
            <el-input class="input-new-tag" v-if="dialog1.inputVisible" v-model="dialog1.inputValue" ref="saveTagInput"
              size="small" @input="dialog1.inputValue = intNumber(dialog1.inputValue)"
              @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button class="button-new-tag" size="small" @click="showInput">+增加商户id</el-button>
          </div>
        </div>
        <div class="timebox">
          <span style="padding-right:10px;margin-right:28px;">二级密码：</span>
          <el-input style="width:185px;" size="small" type="password" v-model="dialog1.secondPassword"></el-input>
        </div>
      </div>
      <p class="tc pdb20">
        <el-button size="small" type="primary" @click="clearorder">确定</el-button>
        <el-button size="small" type="info" @click="dialog1.show = false">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { downSentUrl } from '../../assets/js/version';
import axios from 'axios';
export default {
  data() {
    return {
      ordertime1: this.getCerentTime(true), // 订单时间
      ordertime2: this.getCerentTime(false), // 订单时间
      // startTime: this.getCerentTime(true),
      // endTime: this.getCerentTime(false),
      ordernumber: '', // 订单编号
      accountnumber: '', // 商户账号
      gameaccount: '', // 游戏账号
      Orderstatus: '', // 订单状态
      Orderdrow: [
        { text: '未支付', value: 0 },
        { text: '支付成功', value: 1 },
        { text: '等待下发', value: 2 },
        { text: '退款订单', value: 3 }
      ], // 订单状态下拉
      derive: '', // 导出
      derivedrow: [{ text: '玩家QQ', value: 1 }], // 导出下拉
      rechargemode: '', // 充值方式
      rechargedrow: [], // 充值方式下拉
      rechargeChannel: '', // 充值通道
      Channeldrow: [], // 充值通道下拉
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      pageIndex: 1, // 页码
      pageSize: 20, // 每页的条数
      total: 0, // 总数据的条数
      upinfo: {
        amount: 0,
        merchantProfit: 0,
        payAmount: 0,
        tailAmountProfit: 0,
        platformProfit: 0,
        successCount: 0,
        randomMoney : 0
      },
      downinfo: {
        amount: 0,
        merchantProfit: 0,
        payAmount: 0,
        tailAmountProfit: 0,
        platformProfit: 0,
        successCount: 0,
        randomMoney : 0
      },
      tableData: [], // 平台列表
      waitFlag: false,
      waitFlagIndex: '',
      dialog: {
        show: false, // 弹框的显隐
        sysorder: '', // 系统订单
        serverorder: '', // 服务订单
        merchantaccount: '', // 商户账号
        area: '', // 分区
        playaccount: '', // 玩家帐号
        chargetype1: '', // 充值方式1
        chargetype2: '', // 充值方式2
        ordertime: '', // 下单时间
        finishtime: '', // 完成时间
        ordermoney: 0, // 订单金额
        paymoney: 0, // 付款金额
        givemoney: 0, // 赠送金额
        redmoney: 0, // 红包金额
        merchantProfit: 0, // 商户收入
        merchantrate: '', // 商户比率
        orderProfit: 0, // 订单收入
        platrate: '', // 平台比率
        tialProfit: 0, // 风控收入
        tialRate: '', // 风控比率
        changeRank: '', // 兑换比例
        orderState: '', // 订单状态
        playerIp: '', // 玩家ip
        playerQQ: '' // 玩家QQ
      },
      dialog1: {
        show: false,
        time: '',
        merchantId: [],
        inputVisible: false,
        inputValue: '',
        secondPassword: '' // 二级密码
      },
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          let three = 30 * 24 * 3600 * 1000;
          let threeMonths = curDate - three;
          return time.getTime() > threeMonths;
        }
      }
    };
  },
  filters: {
    orderState: function (data) {
      let state = '';
      switch (data) {
        case 0:
          state = '未支付';
          break;
        case 1:
          state = '支付成功';
          break;
        case 2:
          state = '等待下发';
          break;
        case 3:
          state = '退款订单';
          break;
      }
      return state;
    }
  },
  methods: {
    // 获取订单平台列表
    getlist() {
      this.$api.order
        .platlist({
          StartTime: this.ordertime1 ? this.ordertime1 : '',
          EndTime: this.ordertime2 ? this.ordertime2 : '',
          OrderNumber: this.ordernumber,
          Account: this.accountnumber,
          PlayerAccount: this.gameaccount,
          State: this.Orderstatus === '' ? -1 : this.Orderstatus,
          GalleryId: this.rechargeChannel === '' ? 0 : this.rechargeChannel,
          ProductId: this.rechargemode === '' ? 0 : this.rechargemode,
          AmountMin:
            this.ontherecharge === '' ? '' : parseFloat(this.ontherecharge),
          AmountMax:
            this.undertherecharge === ''
              ? ''
              : parseFloat(this.undertherecharge),
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取平台信息
    platinfo() {
      this.$api.order
        .platinfo({
          StartTime: this.ordertime1 ? this.ordertime1 : '',
          EndTime: this.ordertime2 ? this.ordertime2 : '',
          OrderNumber: this.ordernumber,
          Account: this.accountnumber,
          PlayerAccount: this.gameaccount,
          State: this.Orderstatus === '' ? -1 : this.Orderstatus,
          GalleryId: this.rechargeChannel === '' ? 0 : this.rechargeChannel,
          ProductId: this.rechargemode === '' ? 0 : this.rechargemode,
          AmountMin:
            this.ontherecharge === '' ? '' : parseFloat(this.ontherecharge),
          AmountMax:
            this.undertherecharge === ''
              ? ''
              : parseFloat(this.undertherecharge),
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 200) {
            this.upinfo.amount = data.data.nowStatistics.amount;
            this.upinfo.merchantProfit = data.data.nowStatistics.merchantProfit;
            this.upinfo.payAmount = data.data.nowStatistics.payAmount;
            this.upinfo.platformProfit = data.data.nowStatistics.platformProfit;
            this.upinfo.successCount = data.data.nowStatistics.successCount;
            this.upinfo.tailAmountProfit =
              data.data.nowStatistics.tailAmountProfit;
            this.upinfo.successRate = data.data.nowStatistics.successRate;
            this.upinfo.randomMoney = data.data.nowStatistics.randomMoney;
            this.downinfo.amount = data.data.yesterdayStatistics.amount;
            this.downinfo.successCount =
              data.data.yesterdayStatistics.successCount;
            this.downinfo.merchantProfit =
              data.data.yesterdayStatistics.merchantProfit;
            this.downinfo.payAmount = data.data.yesterdayStatistics.payAmount;
            this.downinfo.platformProfit =
              data.data.yesterdayStatistics.platformProfit;
            this.downinfo.tailAmountProfit =
              data.data.yesterdayStatistics.tailAmountProfit;
            this.downinfo.successRate =
              data.data.yesterdayStatistics.successRate;
            this.downinfo.randomMoney =
              data.data.yesterdayStatistics.randomMoney;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取订单详情
    orderdetail(id) {
      this.$api.order
        .orderdetail({ Id: id })
        .then((data) => {
          if (data.status === 200) {
            this.dialog.id = data.data.id; // ID
            this.dialog.sysorder = data.data.orderNumber; // 系统订单
            this.dialog.serverorder = data.data.supNumber; // 服务订单
            this.dialog.merchantaccount = data.data.account; // 商户账号
            this.dialog.area = data.data.partitionName; // 分区
            this.dialog.playaccount = data.data.playerAccount; // 玩家帐号
            this.dialog.chargetype1 = data.data.galleryName; // 充值方式1
            this.dialog.chargetype2 = data.data.productName; // 充值方式2
            this.dialog.ordertime = data.data.orderDate; // 下单时间
            this.dialog.finishtime = data.data.payDate; // 完成时间
            this.dialog.ordermoney = data.data.amount.toFixed(2); // 订单金额
            this.dialog.paymoney = data.data.payAmount.toFixed(2); // 付款金额
            this.dialog.givemoney = data.data.giveAmount.toFixed(2); // 赠送金额
            this.dialog.redmoney = data.data.redPacketAmount.toFixed(2); // 红包金额
            this.dialog.merchantProfit = data.data.merchantProfit.toFixed(2); // 商户收入
            this.dialog.merchantrate = data.data.merchantRate; // 商户比率
            this.dialog.orderProfit = data.data.platformProfit.toFixed(2); // 订单收入
            this.dialog.platrate = data.data.platformRate; // 平台比率
            this.dialog.tialProfit = data.data.tailAmountProfit.toFixed(2); // 风控收入
            this.dialog.tialRate = data.data.tailRate; // 风控比率
            this.dialog.changeRank = data.data.ratio; // 兑换比例
            this.dialog.orderState = data.data.state; // 订单状态
            this.dialog.playerIp = data.data.playerIP; // 玩家ip
            this.dialog.playerQQ = data.data.playerQq; // 玩家QQ
            this.dialog.show = true;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框初始化
    dialoginit() {
      this.dialog.id = ''; // ID
      this.dialog.sysorder = ''; // 系统订单
      this.dialog.serverorder = ''; // 服务订单
      this.dialog.merchantaccount = ''; // 商户账号
      this.dialog.area = ''; // 分区
      this.dialog.playaccount = ''; // 玩家帐号
      this.dialog.chargetype1 = ''; // 充值方式1
      this.dialog.chargetype2 = ''; // 充值方式2
      this.dialog.ordertime = ''; // 下单时间
      this.dialog.finishtime = ''; // 完成时间
      this.dialog.ordermoney = ''; // 订单金额
      this.dialog.paymoney = ''; // 付款金额
      this.dialog.givemoney = ''; // 赠送金额
      this.dialog.redmoney = ''; // 红包金额
      this.dialog.merchantProfit = ''; // 商户收入
      this.dialog.merchantrate = ''; // 商户比率
      this.dialog.orderProfit = ''; // 订单收入
      this.dialog.platrate = ''; // 平台比率
      this.dialog.tialProfit = ''; // 风控收入
      this.dialog.tialRate = ''; // 风控比率
      this.dialog.changeRank = ''; // 兑换比例
      this.dialog.orderState = ''; // 订单状态
      this.dialog.playerIp = ''; // 玩家ip
      this.dialog.playerQQ = ''; // 玩家QQ
    },
    // 退款
    refundOrder() {
      this.$api.order
        .refundOrder({ id: this.dialog.id })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('退款成功！');
            this.dialog.show = false;
            this.getlist();
            this.platinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 查询数据
    checkdata() {
      this.pageIndex = 1;
      this.getlist();
      this.platinfo();
    },
    // 充值方式下拉
    rechargetype() {
      this.$api.order
        .productlist()
        .then((data) => {
          if (data.status === 200) {
            this.rechargedrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值通道下拉
    throughdrow() {
      this.$api.order
        .throughlist()
        .then((data) => {
          if (data.status === 200) {
            this.Channeldrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 导出TXT下拉
    // exportExcel() {
    //   /* eslint-disable */
    //   let adressUrl =
    //     url +
    //     '/api/Download/OutputTenantOrderAsync?StartTime=' +
    //     (this.ordertime ? this.ordertime[0] : '') +
    //     '&EndTime=' +
    //     (this.ordertime ? this.ordertime[1] : '') +
    //     '&OrderNumber=' +
    //     this.ordernumber +
    //     '&Account=' +
    //     this.accountnumber +
    //     '&PlayerAccount=' +
    //     this.gameaccount +
    //     '&State=' +
    //     (this.Orderstatus === '' ? -1 : this.Orderstatus) +
    //     '&GalleryId=' +
    //     (this.rechargeChannel === '' ? 0 : this.rechargeChannel) +
    //     '&ProductId=' +
    //     (this.rechargemode === '' ? 0 : this.rechargemode) +
    //     '&AmountMin=' +
    //     (this.ontherecharge === '' ? '' : parseFloat(this.ontherecharge)) +
    //     '&AmountMax=' +
    //     (this.undertherecharge === '' ? '' : parseFloat(this.undertherecharge));
    //   /* eslint-enable */
    //   // 创建隐藏的可下载链接
    //   let eleLink = document.createElement('a');
    //   eleLink.style.display = 'none';
    //   // 字符内容转变成blob地址
    //   eleLink.href = adressUrl;
    //   // 触发点击
    //   document.body.appendChild(eleLink);
    //   eleLink.click();
    //   // 然后移除
    //   document.body.removeChild(eleLink);
    // },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
      this.platinfo();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
      this.platinfo();
    },
    // 清空订单数据请求
    clearorder() {
      this.$api.order
        .clearorder({
          startTime: this.dialog1.time,
          excludeTenant: this.dialog1.merchantId,
          password: this.dialog1.secondPassword
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('清空订单数据成功！');
            this.dialog1 = false;
            this.getlist();
            this.platinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清空订单弹框数据的初始化
    dialoginit1() {
      this.dialog1.time = '';
      this.dialog1.merchantId = [];
      this.dialog1.inputVisible = false;
      this.dialog1.inputValue = '';
      this.dialog1.secondPassword = '';
    },
    handleClose(tag, index) {
      this.dialog1.merchantId.splice(index, 1);
    },
    showInput() {
      this.dialog1.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.dialog1.inputValue;
      if (inputValue) {
        this.dialog1.merchantId.push(parseInt(inputValue));
      }
      this.dialog1.inputVisible = false;
      this.dialog1.inputValue = '';
    },
    // 扣单
    Deduction(id) {
      this.$api.order
        .deductionOrder({ id: id })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('扣单成功！');
            this.getlist();
            this.platinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 扣单提示
    Deductiontip(id) {
      this.$confirm('提示：扣单有风险，确定继续本次扣单操作吗?')
        .then(() => {
          this.Deduction(id);
        })
        .catch(() => { });
    },
    reseting() {
      this.ordertime1 = this.getCerentTime(true);
      this.ordertime2 = this.getCerentTime(false);
      this.ordernumber = ''; // 订单编号
      this.accountnumber = ''; // 商户账号
      this.gameaccount = ''; // 游戏账号
      this.Orderstatus = ''; // 订单状态
      this.rechargemode = ''; // 订单状态
      this.rechargeChannel = ''; // 订单状态
      this.ontherecharge = ''; // 充值金额上
      this.undertherecharge = ''; // 充值金额下
      this.pageIndex = 1;
      this.getlist();
    },
    // 订单下发接口
    orderSentApi(orderNum) {
      axios('/api/ManageOrderIssure/SendSingleOrder', {
        params: {
          orderNumber: orderNum
        },
        method: 'get',
        baseURL: downSentUrl
      })
        .then((data) => {
          if (data.status === 200) {
            setTimeout(() => {
              this.waitFlag = false;
              this.waitFlagIndex = '';
              this.$messageSuccess('下发成功');
              this.getlist();
            }, 1500);
          }
        })
        .catch(() => {
          this.waitFlag = false;
          this.waitFlagIndex = '';
          this.$messageError('下发超时，请检测网关！');
        });
    },
    // 订单下发
    orderSent(orderNum, id, index) {
      if (!this.waitFlag) {
        this.waitFlag = true;
        this.waitFlagIndex = index;
        // 分区检测
        axios('/api/ManageOrderIssure/CheckPartition', {
          params: {
            partitionId: id
          },
          method: 'get',
          baseURL: downSentUrl
        })
          .then((data) => {
            if (data.status === 200) {
              let keyValue = data.data;
              let indexNum = 0;
              let handletimer = setInterval(() => {
                axios('/api/ManageOrderIssure/CheckPartitionStatus', {
                  params: {
                    checkKey: keyValue
                  },
                  method: 'get',
                  baseURL: downSentUrl
                })
                  .then((data) => {
                    clearInterval(handletimer);
                    handletimer = null;
                    this.orderSentApi(orderNum);
                  })
                  .catch(() => {
                    indexNum++;
                    if (indexNum > 6) {
                      clearInterval(handletimer);
                      handletimer = null;
                      this.waitFlag = false;
                      this.waitFlagIndex = '';
                      this.$messageError('分区检测失败！');
                    }
                  });
              }, 500);
            }
          })
          .catch(() => {
            this.waitFlag = false;
            this.waitFlagIndex = '';
            this.$messageError('分区检测失败！');
          });
      }
    }
  },
  created() {
    this.rechargetype();
    this.throughdrow();
    if (this.$route.query.type === 'all') {
      this.ordertime1 = '';
      this.ordertime2 = '';
      this.getlist();
      this.platinfo();
    } else if (this.$route.query.type === 'waitsend') {
      this.Orderstatus = 2;
      this.ordertime1 = '';
      this.ordertime2 = '';
      this.getlist();
      this.platinfo();
    } else if (this.$route.query.type === 'yesterday') {
      this.ordertime1 = this.getYesterday()[0];
      this.ordertime2 = this.getYesterday()[1];
      this.getlist();
      this.platinfo();
    } else {
      this.getlist();
      this.platinfo();
    }
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  padding-right: 0;
  background: #fff;
  position: relative;

  table {
    td {
      padding-bottom: 10px;
      padding-right: 20px;
    }
  }

  .btnbox {
    position: absolute;
    right: 20px;
    top: 15px;
  }

  ul {

    // display: flex;
    // flex-flow: row wrap;
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      // width: 20%;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }

      .txtbox {
        display: inline-block;
      }
    }
  }
}

.tableinfo {
  position: relative;
  background: #fff;
  padding: 8px 20px;

  table {
    // width: 100%;
    color: #272727;
    font-size: 14px;

    td {
      height: 30px;
      padding-right: 50px;
    }

    .c_3fa396 {
      color: #3fa396;
    }
  }

  .btn {
    position: absolute;
    right: 10px;
    top: 24px;
  }
}

.dialogtable {
  width: 100%;

  tr {
    td {
      border: 1px solid #ccc;
      padding: 7px 5px;
      text-align: center;
      font-size: 15px;

      &.tit {
        font-weight: bold;
      }
    }
  }
}

.red {
  color: red;
}

.deleteTip {
  padding-bottom: 10px;

  .tip {
    color: red;
  }

  .timebox {
    margin-top: 10px;
  }

  .inputBox {
    margin-top: 10px;
    display: flex;
    flex-flow: row nowrap;

    .tit {
      width: 108px;
      height: 32px;
      line-height: 32px;
    }

    .merchantBox {
      flex: 1;

      .el-tag {
        position: relative;
        margin-right: 10px;
        margin-bottom: 5px;
        padding-right: 25px;
        min-width: 120px;

        &::v-deep .el-tag__close {
          position: absolute;
          top: 8px;
          right: 5px;
        }
      }

      .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
        margin-bottom: 5px;
        width: 120px;
      }

      .input-new-tag {
        width: 120px;
        vertical-align: bottom;
        margin-bottom: 5px;
        margin-right: 10px;
      }
    }
  }
}
</style>
